// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { FaPlus, FaEye } from "react-icons/fa";
// import {
//   Modal,
//   Button,
//   Form,
//   Table,
//   Pagination,
//   Row,
//   Col,
//   Container,
//   Spinner,
// } from "react-bootstrap";
// import { FaEdit } from "react-icons/fa";
// import { RiDeleteBin3Fill } from "react-icons/ri";
// import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi2";
// import { BsThreeDots } from "react-icons/bs";

// const API_URL = process.env.REACT_APP_API_URL;

// function VisitDateWise() {
//   const navigate = useNavigate();
//   const [expenses, setExpenses] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [dataLoading, setDataLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   const fetchExpenses = async (page = 1) => {
//     const token = getAuthToken();
//     if (!token) {
//       // showCustomMessageModal("Auth Error", "Authentication token not found. Please log in.", "error");
//       setLoading(false);
//       setDataLoading(false);
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await fetch(
//         `${API_URL}/visite-dateWaise?page=${page}&limit=10`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );
//       if (!response.ok) {
//         throw new Error("Failed to fetch expenses.");
//       }
//       const data = await response.json();
//       if (data.success == "1") {
//         setExpenses(data.data);
//         setTotalPages(data.totalPages || 1);
//         setCurrentPage(data.currentPage || page);
//       } else {
//         alert("Error", data.message, "error");
//       }
//     } catch (error) {
//       console.error("Failed to fetch expenses:", error);
//       // showCustomMessageModal("Network Error", "Could not connect to the server.", "error");
//     } finally {
//       setLoading(false);
//       setDataLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchExpenses(currentPage);
//   }, [currentPage]);

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber > 0 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//       fetchExpenses(pageNumber);
//     }
//   };

//   const handleView = (date) => {
//     // If date is already in DD-MM-YYYY format, convert it to YYYY-MM-DD
//     const parts = date.split("-");
//     if (parts.length === 3) {
//       const [day, month, year] = parts;
//       const isoDate = `${year}-${month}-${day}`;
//       navigate(`/visit-by-date/${isoDate}`);
//     } else {
//       // Fallback for other formats
//       const onlyDate = date.split("T")[0];
//       navigate(`/visit-by-date/${onlyDate}`);
//     }
//   };

//   // return (
//   //   <div className="card mt-2">
//   //     <div className="card-header">
//   //       <div className="d-flex justify-content-between align-items-center">
//   //         <div className="titlepage">
//   //           <h3 className="mb-0">Date-wise Visit Report</h3>
//   //         </div>
//   //       </div>
//   //     </div>
//   //     <div class="card-body">
//   //       {dataLoading ? (
//   //         <div className="text-center p-5">
//   //           <Spinner animation="border" />
//   //           <p className="mt-2">Loading expenses...</p>
//   //         </div>
//   //       ) : (
//   //         <>
//   //           <Table striped bordered hover responsive className="shadow-sm">
//   //             <thead>
//   //               <tr>
//   //                 <th>SR.N</th>
//   //                 <th>Visit Date</th>
//   //                 <th>Count</th>
//   //                 <th>Action</th>
//   //               </tr>
//   //             </thead>
//   //             <tbody>
//   //               {expenses.length > 0 ? (
//   //                 expenses.map((expense, index) => {
//   //                   const formattedDate = (() => {
//   //                     const utcDate = new Date(expense.visit_date);
//   //                     const [year, month, day] = utcDate
//   //                       .toISOString()
//   //                       .split("T")[0]
//   //                       .split("-");
//   //                     return `${day}-${month}-${year}`;
//   //                   })();

//   //                   return (
//   //                     <tr key={expense.id}>
//   //                       {/* Corrected serial number calculation */}
//   //                       <td>{(currentPage - 1) * 10 + index + 1}</td>
//   //                       <td>{formattedDate}</td>
//   //                       <td>{expense.total_visits}</td>
//   //                       <td>
//   //                         <button
//   //                           className="btn view_btn btn-sm me-1"
//   //                           title="Date-wise report"
//   //                           onClick={() => handleView(formattedDate)}
//   //                         >
//   //                           <FaEye />
//   //                         </button>
//   //                       </td>
//   //                     </tr>
//   //                   );
//   //                 })
//   //               ) : (
//   //                 <tr>
//   //                   <td colSpan="8" className="text-center">
//   //                     No expenses found.
//   //                   </td>
//   //                 </tr>
//   //               )}
//   //             </tbody>
//   //           </Table>

//   //           <div className="d-flex justify-content-end">
//   //             <nav>
//   //               <ul className="pagination">
//   //                 <li className="page-item">
//   //                   <button
//   //                     className="page-link"
//   //                     onClick={() => handlePageChange(currentPage - 1)}
//   //                     disabled={currentPage === 1}
//   //                     aria-label="Previous"
//   //                   >
//   //                     <HiOutlineChevronLeft />
//   //                   </button>
//   //                 </li>

//   //                 {[...Array(totalPages)].map((_, index) => (
//   //                   <li key={index + 1} className="page-item">
//   //                     <button
//   //                       className={`page-link ${index + 1 === currentPage ? "active" : ""}`}
//   //                       onClick={() => handlePageChange(index + 1)}
//   //                     >
//   //                       {index + 1}
//   //                     </button>
//   //                   </li>
//   //                 ))}

//   //                 <li className="page-item">
//   //                   <button
//   //                     className="page-link"
//   //                     onClick={() => handlePageChange(currentPage + 1)}
//   //                     disabled={currentPage === totalPages}
//   //                     aria-label="Next"
//   //                   >
//   //                     <HiChevronRight />
//   //                   </button>
//   //                 </li>
//   //               </ul>
//   //             </nav>
//   //           </div>
//   //         </>
//   //       )}
//   //     </div>
//   //   </div>
//   // );
//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               📅
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Date-wise Visit Report
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Summary of visits grouped by date
//               </p>
//             </div>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background:
//                   "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "30px" }}>
//               {dataLoading ? (
//                 <div className="text-center p-5">
//                   <Spinner animation="border" />
//                   <p className="mt-3">Loading expenses...</p>
//                 </div>
//               ) : (
//                 <>
//                   <Table
//                     striped
//                     bordered
//                     hover
//                     responsive
//                     className="shadow-sm"
//                   >
//                     <thead>
//                       <tr>
//                         <th>SR.N</th>
//                         <th>Visit Date</th>
//                         <th>Count</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {expenses.length > 0 ? (
//                         expenses.map((expense, index) => {
//                           const formattedDate = (() => {
//                             const utcDate = new Date(expense.visit_date);
//                             const [year, month, day] = utcDate
//                               .toISOString()
//                               .split("T")[0]
//                               .split("-");
//                             return `${day}-${month}-${year}`;
//                           })();

//                           return (
//                             <tr key={expense.id}>
//                               <td>
//                                 {(currentPage - 1) * 10 + index + 1}
//                               </td>
//                               <td>{formattedDate}</td>
//                               <td>{expense.total_visits}</td>
//                               <td>
//                                 <button
//                                   className="btn view_btn btn-sm me-1"
//                                   title="Date-wise report"
//                                   onClick={() => handleView(formattedDate)}
//                                 >
//                                   <FaEye />
//                                 </button>
//                               </td>
//                             </tr>
//                           );
//                         })
//                       ) : (
//                         <tr>
//                           <td colSpan="8" className="text-center">
//                             No expenses found.
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </Table>

//                   {/* Pagination */}
//                   <div className="d-flex justify-content-end">
//                     <nav>
//                       <ul className="pagination">
//                         <li className="page-item">
//                           <button
//                             className="page-link"
//                             onClick={() =>
//                               handlePageChange(currentPage - 1)
//                             }
//                             disabled={currentPage === 1}
//                             aria-label="Previous"
//                           >
//                             <HiOutlineChevronLeft />
//                           </button>
//                         </li>

//                         {[...Array(totalPages)].map((_, index) => (
//                           <li key={index + 1} className="page-item">
//                             <button
//                               className={`page-link ${
//                                 index + 1 === currentPage ? "active" : ""
//                               }`}
//                               onClick={() => handlePageChange(index + 1)}
//                             >
//                               {index + 1}
//                             </button>
//                           </li>
//                         ))}

//                         <li className="page-item">
//                           <button
//                             className="page-link"
//                             onClick={() =>
//                               handlePageChange(currentPage + 1)
//                             }
//                             disabled={currentPage === totalPages}
//                             aria-label="Next"
//                           >
//                             <HiChevronRight />
//                           </button>
//                         </li>
//                       </ul>
//                     </nav>
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>
//     </>
//   );
  
// }

// export default VisitDateWise;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { Spinner } from "react-bootstrap";

const API_URL = process.env.REACT_APP_API_URL;

function VisitDateWise() {
  const navigate = useNavigate();
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const limit = 10;

  const getAuthToken = () => localStorage.getItem("token");

  // ═══════════════════════════════════════════
  // 🔹 FETCH VISITS BY DATE
  // ═══════════════════════════════════════════
  const fetchExpenses = async (page = 1) => {
    const token = getAuthToken();
    if (!token) {
      setLoading(false);
      setDataLoading(false);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${API_URL}/visite-dateWaise?page=${page}&limit=${limit}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch visits.");
      }
      const data = await response.json();
      if (data.success == "1") {
        setExpenses(data.data || []);
        setTotalPages(data.totalPages || 1);
        setCurrentPage(data.currentPage || page);
        setTotalItems(data.total || data.data?.length || 0);
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error("Failed to fetch visits:", error);
    } finally {
      setLoading(false);
      setDataLoading(false);
    }
  };

  useEffect(() => {
    fetchExpenses(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      fetchExpenses(pageNumber);
    }
  };

  const handleView = (date) => {
    const parts = date.split("-");
    if (parts.length === 3) {
      const [day, month, year] = parts;
      const isoDate = `${year}-${month}-${day}`;
      navigate(`/visit-by-date/${isoDate}`);
    } else {
      const onlyDate = date.split("T")[0];
      navigate(`/visit-by-date/${onlyDate}`);
    }
  };

  // ─── Pagination numbers ───
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;
    pages.push(1);
    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");
    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);
    for (let i = start; i <= end; i++) pages.push(i);
    if (showEllipsis && currentPage < totalPages - 3)
      pages.push("right-ellipsis");
    if (totalPages > 1) pages.push(totalPages);
    return pages;
  };

  // ═══════════════════════════════════════════
  // 🎨 RENDER
  // ═══════════════════════════════════════════
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {/* ═══════ HEADER CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              padding: "24px 30px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "5px",
                background:
                  "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "16px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "26px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              📅
            </div>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Date-wise Visit Report
              </h1>
              <p
                style={{
                  margin: "3px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                Summary of visits grouped by date ({totalItems} total records)
              </p>
            </div>
          </div>

          {/* ═══════ MAIN CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "24px 30px" }}>
              {dataLoading ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "70px 20px",
                    color: "#64748b",
                  }}
                >
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      border: "3px solid #cbd5e1",
                      borderTop: "3px solid #2b6cb0",
                      borderRadius: "50%",
                      display: "inline-block",
                      animation: "spin 0.8s linear infinite",
                    }}
                  />
                  <p
                    style={{
                      marginTop: "18px",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    Loading visits...
                  </p>
                </div>
              ) : (
                <>
                  <div
                    style={{
                      overflowX: "auto",
                      overflowY: "visible",
                      borderRadius: "14px",
                      border: "1.5px solid #e2e8f0",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        minWidth: "700px",
                        borderCollapse: "collapse",
                        fontSize: "13px",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            background:
                              "linear-gradient(135deg, #1e5799, #2b6cb0)",
                          }}
                        >
                          {["S.N", "Visit Date", "Visit Count", "Action"].map(
                            (th, i) => (
                              <th
                                key={i}
                                style={{
                                  padding: "14px 14px",
                                  color: "#ffffff",
                                  fontWeight: "700",
                                  fontSize: "11.5px",
                                  textAlign: "left",
                                  letterSpacing: "0.5px",
                                  textTransform: "uppercase",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {th}
                              </th>
                            )
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {expenses.length > 0 ? (
                          expenses.map((expense, index) => {
                            const formattedDate = (() => {
                              const utcDate = new Date(expense.visit_date);
                              const [year, month, day] = utcDate
                                .toISOString()
                                .split("T")[0]
                                .split("-");
                              return `${day}-${month}-${year}`;
                            })();

                            return (
                              <tr
                                key={expense.id}
                                style={{
                                  borderBottom: "1px solid #f1f5f9",
                                }}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.background =
                                    "#f8fafc")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.background =
                                    "transparent")
                                }
                              >
                                <td
                                  style={{
                                    padding: "14px",
                                    fontWeight: "700",
                                    color: "#1e5799",
                                  }}
                                >
                                  {(currentPage - 1) * limit + index + 1}
                                </td>
                                <td style={{ padding: "14px" }}>
                                  <span
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      padding: "6px 14px",
                                      borderRadius: "20px",
                                      background:
                                        "linear-gradient(135deg, #e8f1fb, #dbeafe)",
                                      color: "#1e5799",
                                      fontWeight: "700",
                                      fontSize: "12px",
                                      border: "1.5px solid #bfdbfe",
                                    }}
                                  >
                                    📅 {formattedDate}
                                  </span>
                                </td>
                                <td style={{ padding: "14px" }}>
                                  <span
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      minWidth: "44px",
                                      height: "30px",
                                      padding: "0 12px",
                                      borderRadius: "8px",
                                      background:
                                        "linear-gradient(135deg, #f3e8ff, #e9d5ff)",
                                      color: "#7c3aed",
                                      fontWeight: "800",
                                      fontSize: "13px",
                                      border: "1.5px solid #d8b4fe",
                                    }}
                                  >
                                    {expense.total_visits}
                                  </span>
                                </td>
                                <td style={{ padding: "14px" }}>
                                  <button
                                    onClick={() =>
                                      handleView(formattedDate)
                                    }
                                    title="View Date-wise Report"
                                    style={{
                                      padding: "8px 16px",
                                      borderRadius: "10px",
                                      border: "none",
                                      background:
                                        "linear-gradient(135deg, #1e5799, #2b6cb0)",
                                      color: "#ffffff",
                                      fontSize: "12.5px",
                                      fontWeight: "700",
                                      cursor: "pointer",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      boxShadow:
                                        "0 4px 12px rgba(30, 87, 153, 0.3)",
                                      transition: "all 0.2s ease",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.transform =
                                        "translateY(-2px)";
                                      e.currentTarget.style.boxShadow =
                                        "0 8px 20px rgba(30, 87, 153, 0.45)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.transform =
                                        "translateY(0)";
                                      e.currentTarget.style.boxShadow =
                                        "0 4px 12px rgba(30, 87, 153, 0.3)";
                                    }}
                                  >
                                    <FaEye size={13} /> View
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td
                              colSpan="4"
                              style={{
                                textAlign: "center",
                                padding: "60px 20px",
                                color: "#94a3b8",
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              📭 No visits found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* ═══════ PAGINATION ═══════ */}
                  {totalPages > 1 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "24px",
                        gap: "6px",
                        flexWrap: "wrap",
                      }}
                    >
                      <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{
                          padding: "8px 14px",
                          borderRadius: "10px",
                          border: "1.5px solid #e2e8f0",
                          background: "#ffffff",
                          color:
                            currentPage === 1 ? "#cbd5e1" : "#1e5799",
                          fontWeight: "700",
                          fontSize: "13px",
                          cursor:
                            currentPage === 1 ? "not-allowed" : "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        ‹ Prev
                      </button>

                      {getPageNumbers().map((p, i) => {
                        if (
                          p === "left-ellipsis" ||
                          p === "right-ellipsis"
                        ) {
                          return (
                            <span
                              key={`ellipsis-${i}`}
                              style={{
                                padding: "0 6px",
                                color: "#94a3b8",
                                fontWeight: "700",
                              }}
                            >
                              ...
                            </span>
                          );
                        }
                        const isActive = p === currentPage;
                        return (
                          <button
                            key={p}
                            onClick={() => handlePageChange(p)}
                            style={{
                              minWidth: "38px",
                              height: "38px",
                              borderRadius: "10px",
                              border: isActive
                                ? "none"
                                : "1.5px solid #e2e8f0",
                              background: isActive
                                ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                                : "#ffffff",
                              color: isActive ? "#ffffff" : "#334155",
                              fontWeight: "700",
                              fontSize: "13px",
                              cursor: "pointer",
                              boxShadow: isActive
                                ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                                : "none",
                              transition: "all 0.18s ease",
                            }}
                          >
                            {p}
                          </button>
                        );
                      })}

                      <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{
                          padding: "8px 14px",
                          borderRadius: "10px",
                          border: "1.5px solid #e2e8f0",
                          background: "#ffffff",
                          color:
                            currentPage === totalPages
                              ? "#cbd5e1"
                              : "#1e5799",
                          fontWeight: "700",
                          fontSize: "13px",
                          cursor:
                            currentPage === totalPages
                              ? "not-allowed"
                              : "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        Next ›
                      </button>
                    </div>
                  )}

                  {expenses.length > 0 && (
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "12px",
                        color: "#94a3b8",
                        marginTop: "12px",
                        marginBottom: 0,
                        fontWeight: "500",
                      }}
                    >
                      Page {currentPage} of {totalPages} • {totalItems} total
                      records
                    </p>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Footer Copyright */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}

export default VisitDateWise;
